import Image from "next/image";
import type { FC } from "react";

export interface IconTitleProps {
  icon: string | null;
  title: string;
  subtitle: string;
}

export const IconTitle: FC<IconTitleProps> = ({ icon, title, subtitle }) => {
  return (
    <div className="flex gap-3 text-left items-center">
      <div className="w-10 h-10 relative">
        {icon ? (
          <Image src={icon} alt={`${title} asset icon`} fill />
        ) : (
          <div className="w-full h-full bg-slate-400 rounded-full" />
        )}
      </div>
      <div>
        <span className="text-lg font-medium block">{title}</span>
        <span className="text-sm text-tertiary-text">{subtitle}</span>
      </div>
    </div>
  );
};
